import styled from "styled-components";

export const IntroText = styled.p`
  font-size: 1.125rem;
  color: #374151;
  margin-bottom: 2rem;
  line-height: 1.6;
`;

export const WidgetStep = styled.div`
  margin-bottom: 3rem;
  padding: 1.5rem;
  background: #f9fafb;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
`;

export const StepTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  
  &:before {
    content: '';
    width: 0.75rem;
    height: 0.75rem;
    background: #3b82f6;
    border-radius: 50%;
    margin-right: 0.75rem;
  }
`;

export const StepDescription = styled.p`
  font-size: 1rem;
  color: #6b7280;
  margin-bottom: 1rem;
  line-height: 1.5;
`;